import type { Logger } from "@expert/logging";

import { getGamificationApiClient } from "@/sales-tools/api/api";
import { getSelectedSessionId } from "@/sdk";

import type { Reaction } from "../../models";

export const sendReaction = async (logger: Logger, targetExpertId: string, reactionType: Reaction) => {
    const childLogger = logger.child({ targetExpertId, reactionType, sessionId: getSelectedSessionId() });
    try {
        logger.info("Sending reaction");
        return await getGamificationApiClient()
            .post("v1/reaction", { json: { targetExpertId, reactionType } })
            .json<boolean>();
    } catch (error: unknown) {
        childLogger.warn({ error }, "sendReaction failure");
        return false;
    }
};
